import {createContext} from 'react'
function noop() {}
export const SelectionCriteriaContext = createContext({
    currentFilterFront: [{
        field: {value: '', label: ''},
        operand: {value: '', label: ''},
        value: ''
    }],
    listName: "",
    type: "app",
    filterFields: [],
    operands: [],
    actions: {
        onChangeField: noop,
        onChangeOperand: noop,
        onChangeFilterValue: noop,
        onChangeFilterValueExternal: noop,
        onChangeFilterValueRange: noop,
        onCreateFilter: noop,
        onDeleteFilter: noop,
        onDeleteAllFilters: noop,
        onChangeType: noop,
        apply: noop
    },
    onClose: noop,
    disabled: false,
    dispatch: noop
});